module.exports = __webpack_public_path__ + "static/media/services_arrow_2.16cd504c.svg";